import { API_URL } from "helpers/constant";
import { request } from "./api";

export function loginRequest(body) {
  return request({
    url: `${API_URL}/auth/login`,
    method: "POST",
    body: JSON.stringify(body),
  });
}
